var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M660.9,0c-14.4,0-26.1,11.7-26.1,26.1v26.1h-52.2V26.1c0-14.4-11.7-26.1-26.1-26.1c-14.4,0-26.1,11.7-26.1,26.1v26.1h-52.2 V26.1c0-14.4-11.7-26.1-26.1-26.1c-14.4,0-26.1,11.7-26.1,26.1v26.1h-52.2V26.1c0-14.4-11.7-26.1-26.1-26.1s-26.1,11.7-26.1,26.1 v26.1h-52.2V26.1c0-14.4-11.7-26.1-26.1-26.1c-14.4,0-26.1,11.7-26.1,26.1v26.1h-52.2V26.1c0-14.4-11.7-26.1-26.1-26.1 C124.7,0,113,11.7,113,26.1v747.8c0,14.4,11.7,26.1,26.1,26.1c14.4,0,26.1-11.7,26.1-26.1v-26.1h52.2v26.1 c0,14.4,11.7,26.1,26.1,26.1s26.1-11.7,26.1-26.1v-26.1h52.2v26.1c0,14.4,11.7,26.1,26.1,26.1c14.4,0,26.1-11.7,26.1-26.1v-26.1 h52.2v26.1c0,14.4,11.7,26.1,26.1,26.1c14.4,0,26.1-11.7,26.1-26.1v-26.1h52.2v26.1c0,14.4,11.7,26.1,26.1,26.1s26.1-11.7,26.1-26.1 v-26.1h52.2v26.1c0,14.4,11.7,26.1,26.1,26.1c14.4,0,26.1-11.7,26.1-26.1V26.1C687,11.7,675.3,0,660.9,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMat);
export default __webpack_public_path__ + "static/media/mat.852fe73fc7eaf0d5bc76a0ef931f14f9.svg";
export { ForwardRef as ReactComponent };